module.exports = __webpack_public_path__ + "img/bigcard.fce2ab73.svg";